import React from 'react'
import { createUseStyles } from 'react-jss'
import COLORS from 'styles/colors'

type Props = {
  radius?: number
  stroke?: number
  progress: number
}

const ProgressRing = ({ radius = 80, stroke = 15, progress }: Props) => {
  const classes = useStyles({ radius, stroke })
  const normalizedRadius = radius - stroke * 2
  const circumference = normalizedRadius * 2 * Math.PI
  const strokeDashoffset = circumference - (progress / 100) * circumference

  const getRingColor = () => {
    if (progress <= 33) {
      return COLORS.uiSpecific.success
    }

    if (progress <= 66) {
      return COLORS.uiSpecific.warning
    }

    if (progress <= 100) {
      return COLORS.uiSpecific.danger
    }
  }

  return (
    <div className={classes.container}>
      <div className={classes.progressTextContainer}>
        <p className={classes.progressText}>{`${progress}%`}</p>
        <p className={classes.text}>de 0 a 100</p>
      </div>
      <svg height={radius * 2} width={radius * 2} style={{ position: 'absolute' }}>
        <circle
          className={classes.circle}
          stroke={getRingColor()}
          fill='transparent'
          strokeWidth={stroke}
          strokeDasharray={circumference + ' ' + circumference}
          style={{ strokeDashoffset, position: 'absolute' }}
          stroke-width={stroke}
          r={normalizedRadius}
          cx={radius}
          cy={radius}
        />
      </svg>
      <svg height={radius * 2} width={radius * 2}>
        <circle
          className={classes.circle}
          stroke={COLORS.greyscale.light}
          fill='transparent'
          strokeWidth={stroke}
          strokeDasharray={circumference + ' ' + circumference}
          // style={{ strokeDashoffset }}
          stroke-width={stroke}
          r={normalizedRadius}
          cx={radius}
          cy={radius}
        />
      </svg>
    </div>
  )
}

const useStyles = createUseStyles({
  container: {
    position: 'relative',
  },
  circle: {
    transition: 'stroke-dashoffset 0.35s',
    transform: 'rotate(-90deg)',
    transformOrigin: '50% 50%',
    borderRadius: '50%',
  },
  progressTextContainer: (props) => ({
    position: 'absolute',
    top: props.radius,
    left: props.radius,
    transform: 'translate(-50%, -50%)',
  }),
  progressText: {
    fontSize: 16,
    fontWeight: 'bold',
    color: COLORS.greyscale.black,
    textAlign: 'center',
  },
  text: {
    fontSize: 14,
    color: COLORS.greyscale.black,
    textAlign: 'center',
  },
})

export default ProgressRing
